(function(angular){
	'use strict';
	
	angular
		.module('additionalInvestmentLandingModule')
		.controller('AdditionalInvestmentLanding', [
			'$filter',
			'$rootScope',
			'$scope',
			'$timeout',
			'$window',
			'AdditionalInvestmentFactory',
			'Big',
			'CheckoutFactory',
			'globalConfig',
			'InvestmentEntityFactory',
			'INVESTMENT_ENTITY_ID',
			'mixpanelFactory',
			'PlaidFactory',
			'ServiceLevelFactory',
			'urlFactory',
			AdditionalInvestmentLandingFunction
		]);
	
	function AdditionalInvestmentLandingFunction(
		$filter, 
		$rootScope,
		$scope,
		$timeout,
		$window,
		AdditionalInvestmentFactory,
		Big,
		CheckoutFactory,
		globalConfig,
		InvestmentEntityFactory,
		INVESTMENT_ENTITY_ID,
		mixpanelFactory,
		PlaidFactory,
		ServiceLevelFactory,
		urlFactory){

		var additionalInvestmentLanding = this;

		function buildPayload() {
			var payload = {
				amount: additionalInvestmentLanding.amount.value
			};

			if(angular.isDefined(additionalInvestmentLanding.paymentMethod)) {
				payload.paymentMethodId = additionalInvestmentLanding.paymentMethod.id;
			}

			if(angular.isDefined(additionalInvestmentLanding.reitOfferingVintageId)) {
				payload.reitOfferingVintageId = additionalInvestmentLanding.reitOfferingVintageId;
			}

			if(angular.isDefined(additionalInvestmentLanding.riaPlanId)) {
				payload.riaPlanId = additionalInvestmentLanding.riaPlanId;
			}

			if(angular.isDefined(additionalInvestmentLanding.serviceLevelUpgrade)) {
				payload.serviceLevelUpgrade = additionalInvestmentLanding.serviceLevelUpgrade;
			}

			return payload;
		}

		function createOrderGroupAndContinueToAgreements() {
			CheckoutFactory.createOrderGroup(buildPayload(), additionalInvestmentLanding.orderForm)
				.then(function(data) {
					additionalInvestmentLanding.reitInvestmentOrderGroupId = data.orderGroupId;
					$timeout(function() {
						$window.document.getElementById('additional-investment-form').submit();
					});
				}).catch(function() {
					additionalInvestmentLanding.formSubmitted = false;
				});
		}

		function createOrderGroupAndContinueToPremiumAccreditation() {
			CheckoutFactory.createOrderGroup(buildPayload(), additionalInvestmentLanding.orderForm)
				.then(function(data) {
					additionalInvestmentLanding.reitInvestmentOrderGroupId = data.orderGroupId;
					$timeout(function() {
						$window.document.getElementById('premium-invest-and-upgrade-redirect-form').submit();
					});
				}).catch(function() {
					additionalInvestmentLanding.formSubmitted = false;
				});
		}

		function getAmountOptionsAndDefault() {
			var amountOptionsAndDefault;
			var amountFromUrlParam = urlFactory.getUrlParam('defaultAmount');

			amountOptionsAndDefault = AdditionalInvestmentFactory.getAmountOptionsAndDefault(
				amountFromUrlParam,
				additionalInvestmentLanding.fixedAmount,
				additionalInvestmentLanding.isRiaOrder,
				additionalInvestmentLanding.nextServiceLevel,
				additionalInvestmentLanding.reitType);
			
			return amountOptionsAndDefault;
		}

		function getIsAboveUpgradeCommunicationThreshold() {
			var nextServiceLevel = additionalInvestmentLanding.nextServiceLevel;
			if(angular.isDefined(nextServiceLevel)) {
				return ServiceLevelFactory.getIsAboveUpgradeCommunicationThreshold(nextServiceLevel.principalInvestedToDate, nextServiceLevel.upgradeCommunicationThreshold, additionalInvestmentLanding.amount.value);
			} else {
				return false;
			}
		}

		function getIsAboveUpgradeThreshold() {
			var nextServiceLevel = additionalInvestmentLanding.nextServiceLevel;

			if(angular.isDefined(nextServiceLevel)) {
				return ServiceLevelFactory.getIsAboveUpgradeThreshold(nextServiceLevel.principalInvestedToDate, nextServiceLevel.upgradeThreshold, additionalInvestmentLanding.amount.value);
			} else {
				return false;
			}
		}

		function getOrderAllocation() {
			var baseUrl = '/api-secured/investment-entity/' + INVESTMENT_ENTITY_ID + '/investment/allocation';
			var urlParams = {
				amount: additionalInvestmentLanding.amount.value,
				riaPlanId: additionalInvestmentLanding.riaPlanId
			};
			var formattedUrl = urlFactory.serializeParamsAndCreateUrl(baseUrl, urlParams);
			return urlFactory.apiGetPromise(formattedUrl);
		}

		function getShouldShowUpgradePrompt() {
			return additionalInvestmentLanding.isAboveUpgradeCommunicationThreshold &&
				additionalInvestmentLanding.isRiaOrder;
		}

		function initInvestmentAmounts() {
			var orderDetails = {
				isIraEntity: additionalInvestmentLanding.entityType === 'IRA'
			};

			if (angular.isDefined(additionalInvestmentLanding.reitOfferingVintageId)) {
				orderDetails.reitOfferingVintageId = additionalInvestmentLanding.reitOfferingVintageId;
			}
			if (angular.isDefined(additionalInvestmentLanding.riaPlanId)) {
				orderDetails.isRepeatRia = true;
			}

			CheckoutFactory.getInvestmentRange(orderDetails)
				.then(function (investmentRange) {
					angular.extend(additionalInvestmentLanding, investmentRange);
				});
		}

		function onPlaidLinkError() {
			$rootScope.ModalFactory.openDisclaimer('invalid-plaid-account-selected');
			additionalInvestmentLanding.formSubmitted = false;
		}

		function onPlaidLinkExit(onExitStatus) {
			$timeout(function() {
				if(onExitStatus === "institution_not_found") {
					$rootScope.ModalFactory.openDisclaimer('link-bank-account-manually', {
						inputs: {
							title: 'Link Bank Account Manually',
							params: {
								newBankAccountUrl: additionalInvestmentLanding.newBankAccountUrl
							}
						}
					});
				}
				additionalInvestmentLanding.paymentMethod = additionalInvestmentLanding.defaultPaymentMethod;
				additionalInvestmentLanding.formSubmitted = false;
			});
		}

		function onPlaidLinkSuccess(linkedAccount) {
			additionalInvestmentLanding.paymentMethods.unshift(linkedAccount);
			additionalInvestmentLanding.paymentMethods = $filter('unique')(additionalInvestmentLanding.paymentMethods, 'id');
			additionalInvestmentLanding.paymentMethod = additionalInvestmentLanding.paymentMethods[0];

			$timeout(function() {
				if(additionalInvestmentLanding.orderForm.$valid) {
					additionalInvestmentLanding.handleContinue();
				} else {
					additionalInvestmentLanding.formSubmitted = false;
				}
			});
		}

		function redirectToInvestAndUpgrade(serviceLevelName) {
			var redirectUrl;

			if(serviceLevelName === 'ADVANCED') {
				redirectUrl = '../upgrade/plus-plan';
			} else if(serviceLevelName === 'CORE') {
				redirectUrl = '../upgrade/select-core-plan';
			}
			additionalInvestmentLanding.investAndUpgradeForm = {
				redirectUrl: redirectUrl,
				investAndUpgradeAmount: additionalInvestmentLanding.amount.value,
				paymentMethodId: additionalInvestmentLanding.paymentMethod.id
			};

			$timeout(function() {
				urlFactory.submitFormById('invest-and-upgrade-redirect-form');
			});
		}

		additionalInvestmentLanding.handleContinue = function() {
			var enterPremiumInvestUpgradeWorkflow = additionalInvestmentLanding.isAboveUpgradeThreshold && additionalInvestmentLanding.wantsToUpgrade && additionalInvestmentLanding.nextServiceLevel.name === 'PREMIUM';
			var enterIraAdvancedInvestUpgradeWorkflow = additionalInvestmentLanding.isTaxedAsIra && additionalInvestmentLanding.isAboveUpgradeThreshold && additionalInvestmentLanding.wantsToUpgrade && additionalInvestmentLanding.nextServiceLevel.name === 'ADVANCED';
			var enterAdvancedInvestUpgradeWorkflow = !additionalInvestmentLanding.isTaxedAsIra && additionalInvestmentLanding.isAboveUpgradeThreshold && additionalInvestmentLanding.wantsToUpgrade && additionalInvestmentLanding.nextServiceLevel.name === 'ADVANCED';
			var enterCoreInvestUpgradeWorkflow = additionalInvestmentLanding.isAboveUpgradeThreshold && additionalInvestmentLanding.wantsToUpgrade && additionalInvestmentLanding.nextServiceLevel.name === 'CORE';
			var enterPlaidWorkflow = additionalInvestmentLanding.paymentMethod && additionalInvestmentLanding.paymentMethod.id === additionalInvestmentLanding.newPaymentMethodId;

			if(enterPlaidWorkflow) {
				PlaidFactory
					.getPlaid(onPlaidLinkSuccess, onPlaidLinkError, onPlaidLinkExit)
					.open();
			} else if (enterPremiumInvestUpgradeWorkflow) {
				additionalInvestmentLanding.serviceLevelUpgrade = 'PREMIUM';
				if(additionalInvestmentLanding.skipAccreditationInformation) {
					createOrderGroupAndContinueToAgreements();
				} else {
					createOrderGroupAndContinueToPremiumAccreditation();
				}
			} else if(enterIraAdvancedInvestUpgradeWorkflow) {
				additionalInvestmentLanding.serviceLevelUpgrade = 'ADVANCED';
				createOrderGroupAndContinueToAgreements();
			} else if(enterAdvancedInvestUpgradeWorkflow) {
				redirectToInvestAndUpgrade('ADVANCED');
			} else if(enterCoreInvestUpgradeWorkflow) {
				redirectToInvestAndUpgrade('CORE');
			} else {
				createOrderGroupAndContinueToAgreements();
			}
		};

		additionalInvestmentLanding.isUpgradeEligible = function() {
			return additionalInvestmentLanding.isAboveUpgradeThreshold && additionalInvestmentLanding.isRiaOrder;
		};

		additionalInvestmentLanding.$onInit = function() {
			angular.extend(additionalInvestmentLanding, globalConfig);

			if(additionalInvestmentLanding.reitType !== 'FUNDRISE_IPO') {
				initInvestmentAmounts();
			}

			additionalInvestmentLanding.wantsToUpgrade = additionalInvestmentLanding.isRiaOrder;

			ServiceLevelFactory.getCurrentServiceLevel()
				.then(function(currentServiceLevel) {
					additionalInvestmentLanding.currentServiceLevel = currentServiceLevel;
				});

			ServiceLevelFactory.getNextServiceLevel()
				.then(function(nextServiceLevel) {
					additionalInvestmentLanding.nextServiceLevel = nextServiceLevel;
					var amountOptionsAndDefault = getAmountOptionsAndDefault();
					additionalInvestmentLanding.amount = amountOptionsAndDefault.amount;
					additionalInvestmentLanding.amountOptions = amountOptionsAndDefault.amountOptions;
					additionalInvestmentLanding.isAboveUpgradeCommunicationThreshold = getIsAboveUpgradeCommunicationThreshold();
					additionalInvestmentLanding.isAboveUpgradeThreshold = getIsAboveUpgradeThreshold();
					additionalInvestmentLanding.shouldShowUpgradePrompt = getShouldShowUpgradePrompt();

					additionalInvestmentLanding.mixpanelProps = {
						'Investment Entity Type': additionalInvestmentLanding.entityType,
						'Order Type': additionalInvestmentLanding.isRiaOrder ? 'RIA' : 'eDirect',
						'REIT Type': additionalInvestmentLanding.reitType,
						'Default Amount': angular.isDefined(additionalInvestmentLanding.amount) ? additionalInvestmentLanding.amount.value : undefined
					};

					mixpanelFactory.track('Repeat Investment Started', additionalInvestmentLanding.mixpanelProps);
				});

			InvestmentEntityFactory.getPaymentMethodOptions({
				includePlaid: additionalInvestmentLanding.includePlaid,
				includeWire: additionalInvestmentLanding.includeWire
			})
				.then(function(paymentMethods){
					additionalInvestmentLanding.paymentMethods = paymentMethods;
					additionalInvestmentLanding.paymentMethod = $filter('filter')(additionalInvestmentLanding.paymentMethods, { primaryAccount: true}, true)[0];

					if(angular.isUndefined(additionalInvestmentLanding.paymentMethod)) {
						additionalInvestmentLanding.paymentMethod = additionalInvestmentLanding.paymentMethods[0];
					}

					additionalInvestmentLanding.defaultPaymentMethod = additionalInvestmentLanding.paymentMethod;
				});
		};

		$scope.$watch('additionalInvestment.amount', function(newAmount, oldAmount) {

			var shouldUpdateOrderAllocation = angular.isDefined(additionalInvestmentLanding.amount) &&
				angular.isDefined(additionalInvestmentLanding.amount.value) &&
				additionalInvestmentLanding.amount.value !== 'other' &&
				additionalInvestmentLanding.isRiaOrder;

			if(shouldUpdateOrderAllocation) {
				additionalInvestmentLanding.isAboveUpgradeCommunicationThreshold = getIsAboveUpgradeCommunicationThreshold();
				additionalInvestmentLanding.isAboveUpgradeThreshold = getIsAboveUpgradeThreshold();
				additionalInvestmentLanding.shouldShowUpgradePrompt = getShouldShowUpgradePrompt();

				getOrderAllocation()
					.then(function(response) {
						additionalInvestmentLanding.orderAllocation = response.data;
					});
			}

			var shouldTrackMixpanelEvent = angular.isDefined(newAmount) &&
				angular.isDefined(newAmount.value) &&
				angular.isDefined(oldAmount) &&
				newAmount.value !== 'other';

			if(shouldTrackMixpanelEvent) {
				additionalInvestmentLanding.mixpanelProps['New Amount'] = newAmount.value;
				additionalInvestmentLanding.mixpanelProps['Old Amount'] = oldAmount.value;
				mixpanelFactory.track('Repeat Investment Amount Changed', additionalInvestmentLanding.mixpanelProps);
			}
		});

		$scope.$on('repeatInvestmentUpgradePrompt:setCustomAmountToUpgradeAmount', function(evt, amount) {
			$scope.$broadcast('amountSelect:setCustomAmountToUpgradeAmount', amount);
		});
	}
})(window.angular);